import { DialogContent } from "../../../../components/ui/dialog";
import Steps from "./components/Steps";
import useNewC6BankModal from "./useNewC6BankModal";
import Header from "./components/Header";
import PersonalInfoForm from "./components/PersonalInfoForm";
import AddressForm from "./components/AddressForm";
import BankInfoForm from "./components/BankInfoForm";
import ReviewProposal from "./components/ReviewProporsal";
import SentProposal from "./components/SentProposal";

export default function NewC6BankModal() {
  const { title, steps, step } = useNewC6BankModal();

  return (
    <DialogContent className={step < 3 ? "min-w-[896px]" : "min-w-[760px]"}>
      <div className={step < 4 ? "" : "hidden"}>
        <Header title={title[step]} />
        <Steps visible={step < 3} />
        <PersonalInfoForm visible={steps.personalInfo} />
        <AddressForm visible={steps.address} />
        <BankInfoForm visible={steps.bankInfo} />
        <ReviewProposal visible={steps.review} />
        <SentProposal visible={steps.sentProposal} />
      </div>
    </DialogContent>
  );
}
